import { StyleSheet, Text } from 'react-native'
import { NoTransactionsIcon } from './NoTransactionsIcon'
import type { CardActivityFeedBottomSheetProps } from './CardActivityFeedBottomSheet'
import { transactionsTopLevelHeader } from './TopLevelHeader'
import { useCardActivityFeedBottomSheetAnimatedHeight } from './useCardActivityFeedBottomSheetHeightStore'
import { mesaColorNames, typography } from '@/src/common/theme'
import Animated from 'react-native-reanimated'

export function CardActivityFeedEmpty({
  cardActivityFeedBottomSheetHeightStore: { maxHeight, minHeight, animatedIndex },
}: CardActivityFeedBottomSheetProps) {
  const emptyStateAnimatedStyles = useCardActivityFeedBottomSheetAnimatedHeight(
    maxHeight,
    minHeight,
    animatedIndex,
    { justifyContent: 'center', alignItems: 'center' },
    188,
  )

  return (
    <>
      {transactionsTopLevelHeader}
      <Animated.View style={emptyStateAnimatedStyles}>
        <NoTransactionsIcon
          pathProps={{
            stroke: mesaColorNames['Mesa - Brand/Blackish #222222'],
          }}
        />
        <Text style={styles.text}>No recent transactions</Text>
      </Animated.View>
    </>
  )
}

const styles = StyleSheet.create({
  text: {
    marginTop: 16,
    ...typography['label/lg-regular'],
    color: 'black',
  },
})
